import { render, staticRenderFns } from "./AdminTimeDisputeList.vue?vue&type=template&id=2f5646a4&scoped=true&"
import script from "./AdminTimeDisputeList.vue?vue&type=script&lang=js&"
export * from "./AdminTimeDisputeList.vue?vue&type=script&lang=js&"
import style0 from "./AdminTimeDisputeList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminTimeDisputeList.vue?vue&type=style&index=1&id=2f5646a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5646a4",
  null
  
)

export default component.exports